import Vue from 'vue';
import ElementUI from 'element-ui';


import 'element-ui/lib/theme-chalk/index.css';
import './../styl/variables.scss';
import './../styl/ui.scss';

Vue.use(ElementUI);